import { useCallback } from 'react';
type ShareOptions = {
  title?: string;
  text?: string;
  // A path or URL to share instead of the current page's.
  url?: string;
};

// Shares the link only, on every platform. Receiving apps build their own
// preview card from the page's Open Graph tags. Attaching an image instead made
// apps send a separate photo and link on Android, and Safari shows a link plus a
// file as "1 Link and 1 Image".
export function useWebShare(options?: ShareOptions) {
  const share = useCallback(() => {
    const url = options?.url ? new URL(options.url, window.location.href).href : window.location.href;

    // Web Share API
    if (navigator.share) {
      navigator.share({
        title: options?.title ?? document.title,
        text: options?.text,
        url
      }).catch(err => {
        // Ignore user-cancelled share
        if (err?.name !== 'AbortError') {
          console.error(err);
        }
      });
      return;
    }

    // Clipboard fallback
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(() => alert('Link copied to clipboard')).catch(() => window.prompt('Copy this link:', url));
      return;
    }

    // Final fallback
    window.prompt('Copy this link:', url);
  }, [options?.title, options?.text, options?.url]);
  const canShare = typeof navigator !== 'undefined' && (typeof navigator.share === 'function' || typeof navigator.clipboard?.writeText === 'function');
  return {
    share,
    canShare
  };
}